var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g2, _path37, _g3, _path38, _path39, _path40, _g4, _path41, _g5, _path42, _path43, _path44, _g6, _path45, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 110,
    viewBox: "0 0 101 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1177_6003)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8386 50.1062L16.103 60.741V99.3652L47.8386 88.7361V50.1062Z",
    fill: "#EF5050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8384 50.1062L79.5768 60.741V99.3652L47.8384 88.7361V50.1062Z",
    fill: "#DD3E3E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1177_6003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 60,
    width: 32,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8386 60.741H16.103V110H47.8386V60.741Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1177_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8386 110L16.103 99.3652V60.741L47.8386 71.3701V110Z",
    fill: "#FF605C"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.103 99.3652L47.8386 110L79.577 99.3652L47.8386 88.7361L16.103 99.3652Z",
    fill: "#FF605C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 65.9639L31.5283 76.5959L47.8384 71.3701L16.1029 60.741L0.5 65.9639Z",
    fill: "#FF8D8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5768 60.741L47.8384 50.1062L59.8992 45.5901L91.6347 56.2249L79.5768 60.741Z",
    fill: "#FF8D8D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8384 71.3701V110L79.5768 99.3652V60.741L47.8384 71.3701Z",
    fill: "#FF6F6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1514 76.5959L95.8898 65.9639L79.5768 60.741L47.8384 71.3701L64.1514 76.5959Z",
    fill: "#FF8D8D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1029 60.741L47.8384 50.1062L35.7833 45.5901L4.04492 56.2249L16.1029 60.741Z",
    fill: "#FF8D8D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1366 39.6459L26.7294 40.2669C26.7294 40.2669 27.2677 41.6406 25.7615 42.5536C25.7615 42.5536 25.1917 41.8724 25.1201 41.8381C25.2375 41.7351 26.738 41.4346 26.1366 39.6459Z",
    fill: "#009BB5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6153 21.0493C16.6153 21.0493 17.3598 21.885 18.9089 22.5203C18.5653 23.3732 18.5882 23.7853 18.5882 23.7853C18.5882 23.7853 16.9618 23.5277 16.2173 22.5289C16.5437 21.7991 16.6153 21.0493 16.6153 21.0493Z",
    fill: "#1FBFE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95545 16.3386C4.95545 16.3386 3.83298 15.5402 3.48364 13.906C2.58166 14.0892 1.80566 14.2094 1.80566 14.2094C1.80566 14.2094 2.20082 15.7748 3.05413 16.6849C3.83012 16.496 4.95545 16.3386 4.95545 16.3386Z",
    fill: "#1FBFE5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4268 29.698L16.1771 30.5279C16.1771 30.5279 17.3224 33.1924 15.4211 34.3944C15.4211 34.3944 14.6508 33.4929 14.5649 33.4414C14.7138 33.3069 16.283 32.6772 15.4268 29.698Z",
    fill: "#009BB5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8021 33.7446L20.5523 34.5717C20.5523 34.5717 21.2911 36.1772 19.3668 37.5252C19.3668 37.5252 18.6166 36.6895 18.5278 36.6409C18.6767 36.5064 20.5695 36.1114 19.8021 33.7446Z",
    fill: "#009BB5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5679 33.4385C14.5679 33.4385 17.374 30.3877 20.0829 33.6932L20.5611 34.5775C20.5611 34.5775 18.3218 31.8187 15.4269 34.3915L14.5679 33.4385Z",
    fill: "#1FBFE5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1036 36.9014L23.7594 37.6254C23.7594 37.6254 24.3578 39.2138 22.6999 40.2612C22.6999 40.2612 22.0671 39.4742 21.9897 39.4284C22.1186 39.314 23.7708 38.9705 23.1036 36.9014Z",
    fill: "#009BB5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5278 36.6324C18.5278 36.6324 20.9789 33.9708 23.347 36.8556L23.7622 37.6283C23.7622 37.6283 21.8838 35.3445 19.3525 37.5883L18.5278 36.6324Z",
    fill: "#1FBFE5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9897 39.4285C21.9897 39.4285 24.2204 37.1132 26.3565 39.6059L26.7287 40.2727C26.7287 40.2727 24.9964 38.3066 22.697 40.2613L21.9897 39.4285Z",
    fill: "#1FBFE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61719 32.2393L11.006 32.826C11.006 32.826 13.1822 29.2 16.163 30.525C16.163 30.525 15.7908 30.0557 15.4271 29.6951C14.3505 29.4146 12.2745 28.5875 9.61719 32.2393Z",
    fill: "#1FBFE5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81445 11.0784L11.6385 11.9456L12.9127 10.9325L10.2869 9.55017L9.81445 11.0784Z",
    fill: "#FFF033"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73682 26.4412C1.73682 26.4412 2.83065 26.258 3.39761 24.684C4.26524 24.9873 5.02118 25.2105 5.02118 25.2105C5.02118 25.2105 4.54299 26.2494 3.57515 27.0393C2.83065 26.7445 1.73682 26.4412 1.73682 26.4412Z",
    fill: "#FFF033"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5792 11.9113C79.5792 11.9113 79.3072 12.8528 78.2964 13.4739C78.6343 14.0348 78.8977 14.527 78.8977 14.527C78.8977 14.527 79.8541 13.8888 80.2636 13.1047C79.9515 12.6296 79.5792 11.9113 79.5792 11.9113Z",
    fill: "#007D9E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91.955 22.692L90.9843 23.5592C90.9843 23.5592 89.3407 26.5012 91.3909 28.1182C91.3909 28.1182 92.3874 27.168 92.4962 27.1222C92.3415 26.9505 90.6063 26.0347 91.955 22.692Z",
    fill: "#E0CA00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4055 26.8361L85.4405 27.7032C85.4405 27.7032 84.3925 29.4661 86.4513 31.2577C86.4513 31.2577 87.422 30.3848 87.5309 30.339C87.3676 30.1644 85.2315 29.4833 86.4055 26.8361Z",
    fill: "#E0CA00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4934 27.1222C92.4934 27.1222 89.6214 23.2558 86.0908 26.7473L85.4351 27.7118C85.4351 27.7118 88.3586 24.7955 91.391 28.121L92.4934 27.1222Z",
    fill: "#FFF033"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2109 30.0814L81.3662 30.8398C81.3662 30.8398 80.4757 32.6028 82.2682 34.0137C82.2682 34.0137 83.0929 33.178 83.1874 33.1379C83.0499 32.9891 81.1858 32.3938 82.2109 30.0814Z",
    fill: "#E0CA00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5282 30.3332C87.5282 30.3332 85.0198 26.9562 81.9359 30.0041L81.3604 30.8455C81.3604 30.8455 83.8086 28.4358 86.4601 31.3349L87.5282 30.3332Z",
    fill: "#FFF033"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3709 32.8833L77.6093 33.5358C77.6093 33.5358 76.8189 35.0583 78.4511 36.2947C78.4511 36.2947 79.1927 35.5792 79.2786 35.5449C79.1526 35.4104 77.4546 34.8809 78.3709 32.8833Z",
    fill: "#E0CA00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1872 33.1409C83.1872 33.1409 80.8907 30.196 78.1189 32.8146L77.6035 33.5387C77.6035 33.5387 79.8427 31.481 82.2652 34.0166L83.1872 33.1409Z",
    fill: "#FFF033"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3606 26.3381L96.6827 26.8475C96.6827 26.8475 94.6095 22.3915 91.0073 23.562C91.0073 23.562 91.4941 23.0669 91.9551 22.692C93.2379 22.4945 95.7377 21.7934 98.3606 26.3381Z",
    fill: "#FFF033"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3378 19.6727C98.3378 19.6727 98.8303 18.6768 100.5 18.5852C100.454 17.6665 100.457 16.8795 100.457 16.8795C100.457 16.8795 99.3228 17.0398 98.292 17.7409C98.3607 18.5366 98.3378 19.6727 98.3378 19.6727Z",
    fill: "#FFF033"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7759 21.553C85.7759 21.553 86.8726 21.3698 87.4367 19.7958C88.3072 20.0991 89.0602 20.3252 89.0602 20.3252C89.0602 20.3252 88.5821 21.3641 87.6142 22.1511C86.8697 21.8563 85.7759 21.553 85.7759 21.553Z",
    fill: "#FF8D8D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M94.81 14.7645L94.0913 15.8349C94.0913 15.8349 95.3226 17.1256 96.1988 16.4187L97.0779 15.294C97.0779 15.294 95.3512 15.4886 94.81 14.7645Z",
    fill: "#007D9E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0753 27.5887H35.9321V51.955H36.0753V27.5887Z",
    fill: "#FCEDED"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1934 12.1831C48.1934 5.45764 42.7357 0 36.0037 0C29.2689 0 23.8169 5.45764 23.8169 12.1831C23.8169 18.7283 28.9768 26.8189 35.4511 27.2625L35.1332 27.9722H36.9286L36.7654 27.2453C43.1423 26.6472 48.1934 18.6567 48.1934 12.1831Z",
    fill: "#F2440F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1177_6003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 3,
    width: 5,
    height: 8
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9867 3.54309H26.7832V10.5347H30.9867V3.54309Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1177_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9867 3.54309C30.9867 3.54309 26.4051 4.67354 26.8089 9.40712C27.1554 13.4853 29.5578 5.31461 30.9867 3.54309Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1177_6003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 12,
    width: 3,
    height: 2
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0289 12.4492H26.4912V13.9861H28.0289V12.4492Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1177_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0289 13.2191C28.0289 13.6426 27.6853 13.9889 27.2587 13.9889C26.832 13.9889 26.4941 13.6426 26.4941 13.2191C26.4941 12.7955 26.8378 12.4492 27.2615 12.4492C27.6853 12.4492 28.0289 12.7926 28.0289 13.2191Z",
    fill: "white"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9206 56.7972H48.7803V66.8196H48.9206V56.7972Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0415 41.1312C61.0415 34.4029 55.5837 28.9481 48.8518 28.9481C42.117 28.9481 36.6621 34.4029 36.6621 41.1312C36.6621 47.6735 41.8249 55.767 48.2991 56.2077L47.9813 56.9175H49.7767L49.6135 56.1905C55.9932 55.5953 61.0415 47.6048 61.0415 41.1312Z",
    fill: "#FFABB7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1177_6003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 32,
    width: 5,
    height: 8
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8349 32.4883H39.6313V39.4828H43.8349V32.4883Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1177_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8348 32.4883C43.8348 32.4883 39.2533 33.6216 39.657 38.3552C40.0035 42.4334 42.4059 34.2598 43.8348 32.4883Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1177_6003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 41,
    width: 2,
    height: 2
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.877 41.3973H39.3394V42.9342H40.877V41.3973Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1177_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.877 42.1643C40.877 42.5879 40.5334 42.9342 40.1096 42.9342C39.6858 42.9342 39.3394 42.5879 39.3394 42.1643C39.3394 41.7408 39.6858 41.3973 40.1096 41.3973C40.5334 41.3973 40.877 41.7379 40.877 42.1643Z",
    fill: "white"
  })))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1163 40.1353H60.9702V64.7304H61.1163V40.1353Z",
    fill: "#FCEDED"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2314 24.8184C73.2314 18.09 67.7737 12.6353 61.0417 12.6353C54.3098 12.6353 48.8521 18.09 48.8521 24.8184C48.8521 31.3635 54.0148 39.457 60.4891 39.8977L60.1712 40.6075H61.9666L61.8005 39.8805C68.1803 39.2824 73.2314 31.2948 73.2314 24.8184Z",
    fill: "#FFD629"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1177_6003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 16,
    width: 6,
    height: 8
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0248 16.1783H51.8213V23.1671H56.0248V16.1783Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1177_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0247 16.1783C56.0247 16.1783 51.4432 17.3088 51.847 22.0424C52.1935 26.1206 54.5959 17.9499 56.0247 16.1783Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1177_6003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 25,
    width: 3,
    height: 2
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.067 25.0845H51.5293V26.6213H53.067V25.0845Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1177_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.067 25.8543C53.067 26.2779 52.7234 26.6242 52.2967 26.6242C51.8758 26.6242 51.5293 26.2807 51.5293 25.8543C51.5293 25.4279 51.8758 25.0845 52.2967 25.0845C52.7234 25.0845 53.067 25.4279 53.067 25.8543Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1177_6003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 110,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpen);
export default __webpack_public_path__ + "static/media/boxOpen.881e376b32ff68b2b9e6a70cde829d5e.svg";
export { ForwardRef as ReactComponent };